<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[dataLoaded]="dataLoaded">
</app-base-template>

<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Email Based Ticket & Feedback Config </div>
  </div>
  <div class="modal-body asset-valiation-modal-body">
      <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

      <mat-tab-group mat-align-tabs="center" [selectedIndex]='selectedIndextab' (selectedTabChange)="tabClick($event)">
          <mat-tab label="Add Email Based Ticket Config">
        
    <div class="form-group">
        <mat-radio-group  aria-label="Select an option" [(ngModel)]="selectedTypeValue" (change)="onChnageSenderType()">
            <mat-radio-button class="emailticketradiobtn" *ngFor="let senderType of senderTypeObj" [value] = "senderType.type">{{senderType.type_text}}</mat-radio-button>             
        </mat-radio-group>            
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>

    <div class="row mar-lft-rgt-0">
      <div class="col-md-12 pad-0 category cat-email-ticket">
        <!-- <div class="height-40" [hidden]="categoryLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div> -->
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;"
                (change)="onCategoryChange(ticket,$event.target.value)" id="ticket_{{ticket.id}}"
                [hidden]="!categoryLoaded">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>
    <div class="form-group" *ngIf="selectedTypeValue == 1">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="userSelected"
                (change)="onServiceUserChange($event.target.selectedIndex)">
        <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
      </select>
    </div>
    <div class="form-group" *ngIf="selectedTypeValue == 1">
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="senderValue"
                placeholder="Enter sender email id">
    </div>
    <div class="input-group mb-3" *ngIf="selectedTypeValue == 2">
      <div class="input-group-prepend">
        <span class="input-group-text">@</span>
      </div>
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="senderValue"
              placeholder="Enter sender domain name">
    </div>
    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="keywordVal"
                placeholder="Enter keyword for email subject">

      <!-- <span class="keyword">Keyword : {{ticketTypeEnum}} {{keywordVal}}</span> -->
    </div>
  </mat-tab>
  <mat-tab label="Add Email Base Feedback Config">
      <div class="form-group">
          <mat-radio-group  aria-label="Select an option" [(ngModel)]="selectedTypeValue1" (change)="onChnageSenderType1()">
              <mat-radio-button class="emailticketradiobtn" *ngFor="let senderType of senderTypeObj1" [value] = "senderType.type">{{senderType.type_text}}</mat-radio-button>             
          </mat-radio-group>            
      </div>

      <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text">@</span>
          </div>
          <input type="text" class="form-control radius-0 font-13" [(ngModel)]="domain"
                  placeholder="Enter sender domain name">
        </div>
        <div class="form-group">
          <input type="text" class="form-control radius-0 font-13" [(ngModel)]="keywordVal"
                    placeholder="Enter keyword for email subject">
    
          <!-- <span class="keyword">Keyword : {{ticketTypeEnum}} {{keywordVal}}</span> -->
        </div>
    

  
    </mat-tab>


  </mat-tab-group>

      
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" *ngIf = "!isFeedback"(click)="save()">Save</button>
    <button type="button" class="btn btn-success radius-0" *ngIf = "isFeedback" (click)="submit()">Save</button>

    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>